var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_vm._v("Admin list")])
}
var staticRenderFns = []

export { render, staticRenderFns }